export const SET_TOAST = 'app/toast/SET_TOAST';
